import axios from "axios";
import { toastr } from "react-redux-toastr";
import {
    FETCH_ADD_CART,
    FETCH_REMOVE_CART,
    FETCH_CART,
    FETCH_ERROR,
} from "../types/types";

export const FetchRemoveCart = (productId) => async (dispatch, getState) => {
    dispatch({
        type: FETCH_REMOVE_CART,
        payload: productId,
    });
    toastr.success("Remove from cart");
    localStorage.setItem(
        "cartItems",
        JSON.stringify(getState().cart.cartItems)
    );
    dispatch(refresh());
};

export const FetchCart = () => async (dispatch) => {
    dispatch(refresh());
};

export const FetchAddCart = (product, qty) => async (dispatch, getState) => {
    const { data } = await axios.get(
        `https://shoppi-test.herokuapp.com/api/get/product?id=${product}`
    );
    dispatch({
        type: FETCH_ADD_CART,
        payload: {
            title: data.title,
            image: data.image,
            price: data.price,
            product: data._id,
            qty: parseInt(qty),
        },
    });

    toastr.success("Add to cart");

    localStorage.setItem(
        "cartItems",
        JSON.stringify(getState().cart.cartItems)
    );
    dispatch(refresh());
};

export function error() {
    return {
        type: FETCH_ERROR,
        payload: "Error",
    };
}

export function refresh() {
    return {
        type: FETCH_CART,
    };
}
